<template>
  <div class="MainBox" @click.stop="SelectActive(-1, $self)">

    <!-- 面包屑导航 -->
    <K-Column :column="column"></K-Column>

    <!-- 表单内容 -->
    <div class="box FloatBox">
      <div class="FormStyleTwoLeft FloatBoxRow">
        <ul class="FormStyleTwo">
          <viewer @inited="inited" ref="viewer">
            <li class="FormStyleTwoImgBox FormStyleTwoRow">
              <div class='FormStyleTwoImg backImg' v-if="FormDatas.cover_img"
                :style="{ backgroundImage: 'url(' + FormDatas.cover_img + ')' }">
                <img v-if="FormDatas.cover_img" class="tableImgShow" :src="FormDatas.cover_img" @click="PreviewImgs">
                <span class="icon iconfont iconicon-test33 RemoveImgIcon" @click.stop="RemoveImg"></span>
              </div>
              <div class='FormStyleTwoImg backImg' v-else></div>
              <div class="FormStyleTwoImgMore">
                <p class="hint" style="width:230px">上传经销商图片不能大于2M，格式为 JPG、PNG或GIF</p>
                <p class="btnStyleTwo btnRadius blueBackColor" style="display:table;" @click="HandleModel(true, 1)">上传图片
                </p>
              </div>
            </li>
          </viewer>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle"><i class="redColor">*</i>经销商名称</p>
            <p><input placeholder="请输入经销商名称" v-model="FormDatas.name" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">经销商别名</p>
            <p><input placeholder="请输入经销商别名" v-model="FormDatas.alias" /></p>
          </li>
          <li class="FormStyleTwoRow" v-if="!id">
            <p class="FormStyleTwoTitle"><i class="redColor">*</i>账号</p>
            <p><input placeholder="请输入登录账号" v-model="FormDatas.username" /></p>
          </li>
          <li class="FormStyleTwoRow" v-if="!id">
            <p class="FormStyleTwoTitle"><i class="redColor">*</i>密码</p>
            <p><input placeholder="请输入登录密码" type="password" v-model="FormDatas.password" /></p>
          </li>
          <li class="FormStyleTwoRow" v-if="!userType(3)">
            <p class="FormStyleTwoTitle"><i class="redColor" v-if="!userType(3)">*</i>经纬度</p>
            <p><input placeholder="请点击获取经销商经纬度" v-model="FormDatas.lon_lat" @focus="ClickMap(true)"
                @click="ClickMap(true)" /></p>
          </li>
        </ul>
      </div>
      <div class="FormStyleTwoRight FloatBoxRow" style="min-width: 380px;">
        <div class="FormStyleTwo">
          <li class="FormStyleTwoRow" v-if="userType(3) && role === 30">
            <p class="FormStyleTwoTitle"><i class="redColor">*</i>所在地区</p>
            <div style="display: flex;gap: 10px;" class='SelectStyleArr'
              :style="{ pointerEvents: shouldDisable ? 'none' : 'auto' }">
              <div style="flex: 1; max-width: 150px;" class="SelectStyle SelectStyle3" v-if="!SelectArr[4].datas">
                选择地区
                <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
              </div>
              <div style="flex: 1; max-width: 150px;" class="SelectStyle SelectStyle3"
                @click.stop="SelectActive(4, $self)" v-if="SelectArr[4].datas">
                <div class="SelectStyleValue">{{ SelectArr[4].datas[SelectArr[4].ix].address_name }}</div>
                <ul class="OptionStyleBox" v-if="SelectArr[4].active">
                  <ul class="OptionStyleMain" :class="{ ShowScrollBar: SelectArr[4].datas.length > 6 }">
                    <li class="OptionStyleRow" v-for="(item, index) in SelectArr[4].datas" v-bind:key="index"
                      v-text="item.address_name" @click="SelectData(4, index, item.address_id, item.address_level)">
                    </li>
                  </ul>
                </ul>
                <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
              </div>
              <div style="flex: 1; max-width: 150px;" class="SelectStyle SelectStyle3"
                @click.stop="SelectActive(5, $self)" v-if="SelectArr[5].datas">
                <div class="SelectStyleValue">{{ SelectArr[5].datas[SelectArr[5].ix].address_name }}</div>
                <ul class="OptionStyleBox" v-if="SelectArr[5].active">
                  <ul class="OptionStyleMain" :class="{ ShowScrollBar: SelectArr[5].datas.length > 6 }"
                    v-if="SelectArr[5].datas.length">
                    <li class="OptionStyleRow" v-for="(item, index) in SelectArr[5].datas" v-bind:key="index"
                      v-text="item.address_name" @click="SelectData(5, index, item.address_id, item.address_level)">
                    </li>
                  </ul>
                </ul>
                <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
              </div>
              <div style="flex: 1; max-width: 150px;" class="SelectStyle SelectStyle3"
                @click.stop="SelectActive(6, $self)" v-if="SelectArr[6].datas">
                <div class="SelectStyleValue">{{ SelectArr[6].datas[SelectArr[6].ix].address_name }}</div>
                <ul class="OptionStyleBox" v-if="SelectArr[6].active">
                  <ul class="OptionStyleMain" :class="{ ShowScrollBar: SelectArr[6].datas.length > 6 }"
                    v-if="SelectArr[6].datas">
                    <li class="OptionStyleRow" v-for="(item, index) in SelectArr[6].datas" v-bind:key="index"
                      v-text="item.address_name" @click="SelectData(6, index, item.address_id, item.address_level)">
                    </li>
                  </ul>
                </ul>
                <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
              </div>
              <div class="clear"></div>
            </div>
            <p class="FormStyleOneHint">请选择商户所属地区</p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle"><i class="redColor">*</i>联系人</p>
            <p><input placeholder="可输入联系人名称" v-model="FormDatas.linkman" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle"><i class="redColor">*</i>联系电话</p>
            <p><input placeholder="可输入联系人电话" v-model="FormDatas.linkphone" /></p>
          </li>
          <!-- 数字码改为-1先隐藏 -->
          <li class="FormStyleTwoRow" v-if="userType(-1) && role === 30">
            <p class="FormStyleTwoTitle"><i class="redColor">*</i>邮箱</p>
            <p><input placeholder="可输入邮箱" v-model="FormDatas.email" :disabled="shouldDisable" /></p>
          </li>
          <li class="FormStyleTwoRow" v-if="userType(-1) && role === 30">
            <p class="FormStyleTwoTitle"><i class="redColor">*</i>单位住所</p>
            <p><input placeholder="可输入单位住所" v-model="FormDatas.baddress" :disabled="shouldDisable" /></p>
          </li>
          <li class="FormStyleTwoRow" v-if="userType(-1) && role === 30">
            <p class="FormStyleTwoTitle"><i class="redColor">*</i>信用代码</p>
            <p><input placeholder="可输入信用代码" v-model="FormDatas.organization_code" :disabled="shouldDisable" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">地址</p>
            <p><input placeholder="可输入联系人地址" v-model="FormDatas.linkaddress" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle">描述</p>
            <p>
              <textarea class="form-control" v-model="FormDatas.intro" placeholder="可输入有关经销商的描述介绍"></textarea>
            </p>
          </li>
        </div>
      </div>

      <div class="FormStyleTwoRight FloatBoxRow">
        <div class="FormStyleTwo">
          <li class="FormStyleTwoRow" v-if="userType(-1) && role === 30">
            <p class="FormStyleTwoTitle"><i class="redColor">*</i>所在行业</p>
            <div>
              <el-select @change="tradeChange" v-model="FormDatas.trade_one" filterable placeholder="请选择">
                <el-option v-for="item in SelectArr[2].datas" :key="item.id" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
              <el-select style="padding-left: 10px;" v-model="FormDatas.trade_two" filterable placeholder="请选择">
                <el-option v-for="item in SelectArr[3].datas" :key="item.id" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </div>
            <p class="FormStyleOneHint">请选择正确的行业，不同的行业功能会有所差异</p>
          </li>
          <viewer @inited="inited" ref="viewer">
            <li v-if="userType(-1) && role === 30" class="FormStyleTwoImgBox FormStyleTwoRow"
              style="padding-top: 45px;">
              <div class='FormStyleTwoImg backImg' v-if="FormDatas.blicense"
                :style="{ backgroundImage: 'url(' + FormDatas.blicense + ')' }">
                <img v-if="FormDatas.blicense" class="tableImgShow" :src="FormDatas.blicense" @click="PreviewImgs">
                <span class="icon iconfont iconicon-test33 RemoveImgIcon" @click.stop="RemoveImg"></span>
              </div>
              <div class='FormStyleTwoImg backImg' v-else></div>
              <div class="FormStyleTwoImgMore">
                <p class="hint" style="width:230px"><i class="redColor">*</i>上传经销商营业执照图片不能大于2M，格式为 JPG、PNG或GIF</p>
                <p class="btnStyleTwo btnRadius blueBackColor" v-if="!shouldDisable" style="display:table;"
                  @click="HandleModel(true, 2)">上传图片</p>
              </div>
            </li>
          </viewer>
        </div>
      </div>
    </div>

    <!-- 顶部按钮 -->
    <div class="btnArray formFootBtnArr">
      <a class="btnStyleTwo btnRadius blueBackColor" @click="SubmitForm"><span
          class="icon iconfont iconicon-test17"></span>保存</a>
      <a class="btnStyleTwo btnRadius cyanBackColor" href="javascript:history.back();"><span
          class="icon iconfont iconicon-test18"></span>返回</a>
    </div>

    <!-- 图片空间 -->
    <K-ImagePicker ref="imgPicker" :show-entry="false" @change="selectImg"></K-ImagePicker>

    <div class="mapbox" v-if="mapShow">
      <div class="mapShade" @click="ClickMap(false)"></div>
      <baidu-map :center="{ lng: 116.486915, lat: 40.018724 }" :zoom="14" @ready="handler" :scroll-wheel-zoom="true"
        class="MapMain" @click="getClickInfo">
        <bm-marker :position="{ lng: 116.486915, lat: 40.018724 }" :dragging="true">
          <bm-label content="北京农豪伟业农业科技发展有限公司" :labelStyle="{ color: 'red', fontSize: '13px' }"
            :offset="{ width: -100, height: 30 }" />
        </bm-marker>
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
        <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
      </baidu-map>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

  </div>
</template>

<script>
var self;
import axios from 'axios'
import Paging from '@/components/common/Paging.vue'
import Column from '@/components/common/Column.vue'
import Transition from '@/components/common/Transition.vue'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
import Confirm from '@/components/common/Confirm.vue'
import ImagePicker from '@/components/common/ImagePicker.vue'
export default {
  name: 'DealerEdit',
  components: {
    'K-Paging': Paging,
    'K-Column': Column,
    'K-Transition': Transition,
    'K-Confirm': Confirm,
    'K-Loading': Loading,
    'K-Toast': Toast,
    'K-ImagePicker': ImagePicker
  },
  data() {
    return {
      $self: null,
      page: 1,
      id: null,
      mapShow: false,
      subHint: '数据加载中...',
      isLoding: true,
      loading: false,
      role: 0,
      Toast: {
        state: false,
        type: 0,
        txt: null
      },
      Confirm: {
        state: false,
        txt: null,
        style: 1
      },
      column: [
        { name: 'DealerList', url: 'DealerList' }
      ],
      SelectArr: [{
        ix: 0,
        active: false,
        datas: []
      }, {
        ix: 0,
        active: false,
        datas: null
      }, {
        ix: 0,
        active: false,
        datas: null
      }, {
        ix: 0,
        active: false,
        datas: null
      }, {
        ix: 0,
        active: false,
        datas: null
      }, {
        ix: 0,
        active: false,
        datas: null
      }, {
        ix: 0,
        active: false,
        datas: null
      }
      ],
      FormDatas: {
        cover_img: null,
        lon_lat: null,
        address_detail: null,
        linkaddress: null,
        linkman: null,
        linkphone: null,
        province: null,
        city: null,
        district: null,
        enterprise_user_id: 0,
        enterprise_id: 0,
        baddress: null,
        organization_code: null,
        province_id: null,
        province_name: null,
        city_id: null,
        city_name: null,
        area_id: null,
        area_name: null,
        trade_one: null,
        trade_two: null,
        email: null,
        blicense: null,
        imgIndex: null,
      },
      shouldDisable: false,
    }
  },
  created() {
    self = this;
    self.$self = this;
    self.role = parseInt(localStorage.getItem("wwmxt_Role"));
    axios.defaults.headers.common['token'] = localStorage.getItem("wwmxt_Token");
    self.FormDatas.enterprise_user_id = self.getSafeCode('enterprise_user_id');
    self.FormDatas.enterprise_id = self.getSafeCode('enterprise_user_id');

    if (self.$route.query.id) {
      self.id = self.$route.query.id;
      self.shouldDisable = true;
      self.column[1] = { name: 'DealerEdit', url: 'DealerEdit?id=' + self.$route.query.id };
      self.GetData();
    } else {
      self.shouldDisable = false;
      self.column[1] = { name: 'AddDealer', url: 'DealerEdit' };
    }
    self.GetTrade(); //获取行业
    self.GetAddress(); //获取地区
  },
  methods: {
    tradeChange(event) {
      const selectedItem = self.SelectArr[2].datas.find(item => item.name === event);
      self.GetTrade(1, selectedItem.id);
    },
    GetTrade(rank, id) {
      var tid = 0;
      var trank = 0;
      if (id) {
        tid = id;
      }
      if (rank) {
        trank = rank;
      }
      //获取产品数字身份码质量安全追溯平台行业信息
      const level = trank === 0 ? 1 : 2;
      axios.get(self.GetServerUrl(1) + "safeCodeTrade/" + level + "/" + tid)
        .then(function (response) {
          if (trank === 0) {
            self.SelectArr[2].datas = response.data.meta
            self.FormDatas.trade_one = response.data.meta[0].name;
            self.GetTrade(1, response.data.meta[0].id);
          } else {
            self.SelectArr[3].datas = response.data.meta
            self.FormDatas.trade_two = response.data.meta[0].name;
          }
        }).catch(function (error) {
          console.log("获取行业失败");
        })
    },
    GetAddress(rank, id) {
      let aid = 0;
      let Frank = 0;
      if (id) {
        aid = id;
      }
      if (rank) {
        Frank = rank;
      }
      axios.get(self.GetServerUrl(1) + "address/" + aid)
        .then(function (response) {
          if (Frank === 0) {
            let provinceItem = response.data.meta[0];
            if (self.FormDatas.province) {
              response.data.meta.filter((item, index) => {
                if (item.address_name == self.FormDatas.province) {
                  self.SelectArr[4].ix = index;
                  provinceItem = item;
                }
              })
            }
            self.FormDatas.province_id = provinceItem.address_id  //省id
            self.FormDatas.province_name = provinceItem.address_name
            self.SelectArr[4].datas = response.data.meta
            self.GetAddress(provinceItem.address_level, provinceItem.address_id);  //获取市
          } else if (Frank === 1) {
            let cityItem = response.data.meta[0];
            if (self.FormDatas.city) {
              response.data.meta.filter((item, index) => {
                if (item.address_name == self.FormDatas.city) {
                  self.SelectArr[5].ix = index;
                  cityItem = item;
                }
              })
            }
            if (cityItem.address_level !== 3) { //如果不是直辖市获取县、区
              self.GetAddress(cityItem.address_level, cityItem.address_id);  //获取市
              self.FormDatas.city_id = cityItem.address_id;  //市id
              self.FormDatas.city_name = cityItem.address_name
              self.SelectArr[5].datas = response.data.meta
            } else {
              self.FormDatas.area_id = cityItem.address_id  //县区id
              self.FormDatas.city_name = cityItem.address_name
              self.SelectArr[6].datas = response.data.meta
            }
          } else if (Frank === 2) {
            let areaItem = response.data.meta[0];
            if (self.FormDatas.district) {
              response.data.meta.filter((item, index) => {
                if (item.address_name == self.FormDatas.district) {
                  self.SelectArr[6].ix = index;
                  areaItem = item;
                }
              })
            }


            self.FormDatas.area_id = areaItem.address_id  //县区id
            self.SelectArr[6].datas = response.data.meta
          }
        }).catch(function (response) {
          console.log("获取地址失败");
        })
    },
    SelectData(ix, six, id) {  //选中选择框内容
      self.SelectArr[ix].ix = six;
      let rank = 0;
      if (ix === 2) {
        self.FormDatas.trade_one = self.SelectArr[2].datas[six].name;
        self.GetTrade(1, id);
      } else if (ix === 3) {
        self.FormDatas.trade_two = self.SelectArr[3].datas[six].name;
      } else if (ix === 4) {  //选中省清除市和区的内容并重置索引
        self.FormDatas.province_id = id  //省id
        self.FormDatas.city_id = null
        self.FormDatas.area_id = null
        self.FormDatas.province_name = self.SelectArr[4].datas[six].address_name;
        self.SelectArr[5].ix = 0;
        self.SelectArr[5].datas = null;
        self.FormDatas.city_name = null;
        self.SelectArr[6].ix = 0;
        self.SelectArr[6].datas = null;
        self.FormDatas.area_name = null;
        rank = 1;
      } else if (ix === 5) {  //选中市清除区的内容并重置索引
        self.FormDatas.city_id = id;  //市id
        self.FormDatas.city_name = self.SelectArr[5].datas[six].address_name;
        self.FormDatas.area_id = null
        self.SelectArr[6].ix = 0;
        self.SelectArr[6].datas = null;
        self.FormDatas.area_name = null;
        rank = 2;
      } else if (ix === 6) {
        self.FormDatas.area_id = id  //县区id
        self.FormDatas.area_name = self.SelectArr[6].datas[six].address_name;
        rank = 3;
      }

      //地址选择
      if (ix > 3 && ix < 6 && rank !== 3 && id !== 710000 && id !== 810000 && id !== 820000) {
        self.GetAddress(rank, id);
      }

    },
    HandleModel(status, index) {  //通过外部按钮触发图片空间弹窗
      self.imgIndex = index;
      if (status && self.$refs.imgPicker) {
        self.$refs.imgPicker.openPicker();
      }
    },
    selectImg(img) {
      if (self.imgIndex === 1) {
        self.FormDatas.cover_img = img;
      } else {
        self.FormDatas.blicense = img;
      }
    },
    ChangeToast() {
      self.Toast.state = false;
    },
    ToastFun(type, txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    ConfirmBackFun(data) {
      self.Confirm.state = data.state;
      if (data.state) {
        self.Confirm.state = false;
        history.back();
      }
    },
    GetData() {
      self.loading = true;
      axios.get(self.GetServerUrl(1) + "dealer/" + self.id)
        .then(function (response) {
          if (self.userType(-1)) {
            self.FormDatas = response.data.meta;
            self.FormDatas.enterprise_user_id = self.getSafeCode('enterprise_user_id');
            self.FormDatas.enterprise_id = self.getSafeCode('enterprise_id');
          } else {
            self.FormDatas = response.data.meta;
            self.FormDatas.enterprise_user_id = 0;
            self.FormDatas.enterprise_id = 0;
          }

          self.loading = false;
          if (self.userType(3)) {
            self.GetAddress();
          }
        }).catch(function (error) {
          self.loading = false;
          self.ToastFun(2, self.ErrorHint(error));
        })
    },
    SubmitForm() {
      if (self.userType(3) && !self.FormDatas.lon_lat) { //数字码经纬度默认值
        self.FormDatas.lon_lat = '0';
      }
      if (!self.FormDatas.name) {
        self.ToastFun(2, "名称不能为空！");
        return;
      }
      if (!self.id && (!self.FormDatas.username || !self.FormDatas.password)) {
        self.ToastFun(2, "账号密码不能为空！");
        return;
      }
      if (self.FormDatas.lon_lat.length == 0) {
        self.ToastFun(2, "经纬度不能为空！");
        return;
      }
      if (!self.FormDatas.linkman || !self.FormDatas.linkphone) {
        self.ToastFun(2, "联系人或电话不能为空！");
        return;
      }

      if (self.userType(-1) && self.role === 30) {
        if (!self.FormDatas.email || !self.FormDatas.organization_code || !self.FormDatas.linkphone || !self.FormDatas.linkman || !self.FormDatas.baddress || !self.FormDatas.blicense) {
          self.ToastFun(2, "*号必填项不能为空！");
          return;
        }
      }

      let type;
      if (self.id) {
        type = "patch";
        self.FormDatas.id = self.id;
      } else {
        type = "post";
      }
      self.loading = true;
      axios({
        method: type,
        url: self.GetServerUrl(1) + "dealer",
        data: self.FormDatas
      }).then(function (response) {
        self.loading = false;
        self.Confirm.style = 1;
        self.Confirm.state = true;
        self.Confirm.txt = response.data.message + "，是否确定返回列表？"
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.ToastFun(2, self.ErrorHint(error));  //弹窗提醒
      })
    },
    ClickMap(status) {
      self.loadBaiduMap(() => {
        this.mapShow = status;
      })
    },
    handler({ BMap, map }) { },
    getClickInfo(e) {
      var point = new BMap.Point(e.point.lng, e.point.lat);
      var gc = new BMap.Geocoder();
      gc.getLocation(point, function (rs) {
        var addComp = rs.addressComponents;
        self.FormDatas.linkaddress = rs.address;
        self.FormDatas.address_detail = addComp;
        self.FormDatas.province = addComp.province;
        self.FormDatas.city = addComp.city;
        self.FormDatas.district = addComp.district;
      });
      self.FormDatas.lon_lat = e.point.lng + "," + e.point.lat;
      self.mapShow = false;
    },
    RemoveImg() {
      self.FormDatas.cover_img = null;
    },
    inited(viewer) {
      self.$viewer = viewer
    },
    PreviewImgs() {
      self.$viewer.show();
      self.$viewer.update();
    }
  }
}
</script>

<style scoped></style>
